/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgShare = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M5 20v-8H3v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-8h-2v8z" /><path fill="currentColor" d="M8.4 8.4 7 7l5-5 5 5-1.4 1.4L13 5.8V16h-2V5.8z" /></svg>;
export default SvgShare;